import _createForOfIteratorHelper from "/Users/developer3/udawadi_developer/wiseberry_sass_frontEnd/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
var isDisjoint = function isDisjoint() {
  for (var _len = arguments.length, headers = new Array(_len), _key = 0; _key < _len; _key++) {
    headers[_key] = arguments[_key];
  }
  var sources = headers.filter(Boolean);
  if (sources.length === 0 || sources.length === 1) {
    return true;
  }
  var acc;
  var _iterator = _createForOfIteratorHelper(sources),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var header = _step.value;
      var parameters = Object.keys(header);
      if (!acc || acc.size === 0) {
        acc = new Set(parameters);
        continue;
      }
      for (var _i = 0, _parameters = parameters; _i < _parameters.length; _i++) {
        var parameter = _parameters[_i];
        if (acc.has(parameter)) {
          return false;
        }
        acc.add(parameter);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return true;
};
export default isDisjoint;